import { makeStyles } from '@material-ui/core';
import { tcsmColors } from '../../theme-constants/colors';



export const positionTableStyles = makeStyles((theme) => ({
    positionTable: {
        border: `1px solid ${tcsmColors.greySeven}`,
        boxShadow: '0px 1px 1px rgba(48, 48, 48, 0.3)',

        borderRadius: '3px',
        '& .position-table-row': {
            [theme.breakpoints.up('sm')]: {
                display: 'flex',
            },

            '& + .position-table-row': {
                borderTop: `1px solid ${tcsmColors.greySix}`,
            },
        },
        '& .position-table-cell': {
            padding: theme.spacing(1),
            '&-date': {

                [theme.breakpoints.up('sm')]: {
                    width: '40%',
                },
            },
            '&-title': {
                [theme.breakpoints.up('sm')]: {
                    width: '60%',
                },
                '&-value': {
                    [theme.breakpoints.up('sm')]: {
                        display: 'flex',
                        justifyContent: 'space-between',
                    },
                },
            },
            '& a': {
                [theme.breakpoints.down('sm')]: {
                    display: 'inline-block',
                    marginTop: theme.spacing(1),
                },
            },
        },


    },



}));



